<template>
	<div class="allergens-chooser">
		<AppList :items="this.items" />
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="chooserFontBottomSheet" @toggling-popup="toggleBottomSheet" >
			<FontChooser @save-clicked="handleSaveClicked" v-if="chooserFontBottomSheet" />
		</AppBottomSheet>
	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import AppList from "@/shared/components/AppList.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import FontChooser from "@/console-new/components/config/settings/menu/FontChooser.vue";
import {usePdfStore} from "@/pdf/stores";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		const pdfStore = usePdfStore();
		const notificationStore = useNotificationStore();
		return {
			getString: languageStore.getString,
			userStore,
			pdfStore,
			showNotification: notificationStore.showNotification
		};
	},
	name: "MenuAdvancedOptions",
	mixins: [WindowWidth],
	emits: ["font-save-clicked"],
	components: {
		AppSelect,
		AppList,
		AppBottomSheet,
		FontChooser,
	},
	data() {
		return {
			cornerTypes: [
				{
					title: this.getString("rounded"),
					value: "round"
				},
				{
					title: this.getString("light_rounded"),
					value: "light"
				},
				{
					title: this.getString("squared"),
					value: "squared"
				},
			],
			bannerSize: [
				{
					title: this.getString("small"),
					value: "small"
				},
				{
					title: this.getString("medium"),
					value: "medium"
				},
				{
					title: this.getString("large"),
					value: "large"
				}
			],
			chooserFontBottomSheet: false,
		}
	},
	computed: {
		items() {
			return [
				{title: this.getString("font"), buttonTitle: this.pdfStore.fontsName[this.selectedFontIndex], selectedIndex: this.selectedFontIndex, callbackButton: this.openFontChooser},
				{title: this.getString("corner_type"), selectValues: this.cornerTypes.map((item) => item.title), selectedIndex: this.cornerTypeIndex, callbackSelect: this.setCorner},
				{title: this.getString("banner_size"), selectValues: this.bannerSize.map((item) => item.title), selectedIndex: this.bannerSizeIndex, callbackSelect: this.setBannerSize},
			]
		},
		cornerTypeIndex() {
			if(!this.userStore.currBusiness) {
				return 0;
			}
			let i = this.cornerTypes.findIndex((item) => item.value === this.userStore.currBusiness.round_level);
			if(i === -1) {
				return 0;
			}
			return i;
		},
		bannerSizeIndex() {
			if(!this.userStore.currBusiness) {
				return 0;
			}
			let i = this.bannerSize.findIndex((item) => item.value === this.userStore.currBusiness.banner_size);
			if(i === -1) {
				return 0;
			}
			return i;
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
		selectedFontIndex() {
			if(!this.userStore.currBusiness) {
				return 0;
			}

			let i = this.pdfStore.fontsName.indexOf(this.userStore.currBusiness.custom_font.replaceAll(' ', ''));
			if(i === -1) {
				return 0;
			}
			return i;
		},
	},
	methods: {
		setFont(index) {
			this.userStore.currBusiness.custom_font = this.fonts[index];
		},
		setCorner(index) {
			this.userStore.currBusiness.round_level = this.cornerTypes[index].value;
		},
		setBannerSize(index) {
			this.userStore.currBusiness.banner_size = this.bannerSize[index].value;
		},
		toggleBottomSheet(isOpen) {
			if(!isOpen) {
				this.chooserFontBottomSheet = false;
			}
		},
		openFontChooser() {
			this.chooserFontBottomSheet = true;
		},
		handleSaveClicked() {

			this.userStore.updateBusiness({
				custom_font: this.userStore.currBusiness.custom_font
			}, (success) => {
				if (success) {
					this.showNotification("generic-success");
					this.$emit('font-save-clicked');
					this.chooserFontBottomSheet = false;
				} else {
					this.showNotification("generic-fail");
				}
			});

		},
	},
}
</script>

<style lang="scss" scoped>
.allergens-chooser {

	.default-option {
		display: flex;
		justify-content: space-between;

		.text-explain {
			width: 30%;
			padding: 0 5px;
			text-align: left;
		}

		.text-content {
			width: 70%;
			padding: 0 5px;
			text-align: right;
			color: #9B9B9B;
			font-size: 12px;
		}

		@media (max-width: 600px) {
			flex-direction: column;
			align-items: center;

			.text-explain {
				width: 100%;
				text-align: center;
				margin-bottom: 10px;
			}

			.text-content {
				width: 100%;
				text-align: center;
			}

		}
	}

	.link-option {
		display: flex;
		justify-content: center;
		width: 100%;

		@media (max-width: 500px) {

			.input-wrapper {
				width: 100%;
			}
		}
	}

	.extra-text {
		width: 100%;
		p {
			font-size: 14px;
			line-height: 16px;
			color: #9B9B9B;
		}
		@media(max-width: 400px) {
			p {
				font-size: 12px;
			}
		}
	}
}
</style>